export const GET_GROUPS_SUCCESS = "GET_GROUPS_SUCCESS";
export const GET_GROUP_SUCCESS  = "GET_GROUP_SUCCESS";
export const GET_REQUEST_SUCCESS  = "GET_REQUEST_SUCCESS";
export const GET_REQUEST_ERROR    = "GET_REQUEST_ERROR";
